import { render, staticRenderFns } from "./StandAloneNotFound.vue?vue&type=template&id=2e24ef0f"
import script from "./StandAloneNotFound.vue?vue&type=script&lang=js"
export * from "./StandAloneNotFound.vue?vue&type=script&lang=js"
import style0 from "./StandAloneNotFound.vue?vue&type=style&index=0&id=2e24ef0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports